import { render, staticRenderFns } from "./FeeCategoriesManager.vue?vue&type=template&id=93dcd32a&scoped=true&"
import script from "./FeeCategoriesManager.vue?vue&type=script&lang=js&"
export * from "./FeeCategoriesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dcd32a",
  null
  
)

export default component.exports